import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c(VSheet, {
    staticClass: "stile"
  }, [_c('div', {
    staticClass: "font-weight-medium"
  }, [_vm._v("\n      " + _vm._s(_vm.state.properties.title) + "\n\n      "), _vm.state.properties.faIcon ? _c(VIcon, {
    attrs: {
      "small": ""
    }
  }, [_vm._v("fal fa-" + _vm._s(_vm.state.properties.faIcon))]) : _vm._e()], 1), _c('div', {
    staticClass: "stile-content"
  }, [_vm.isBoolean(_vm.state) ? _c('div', {
    staticClass: "stile-success"
  }, [_c(VIcon, {
    attrs: {
      "size": "70",
      "color": _vm.state.value.value ? 'success' : 'danger'
    }
  }, [_vm._v("\n          " + _vm._s(_vm.state.value.value ? 'fal fa-check-circle' : 'fal fa-times') + "\n        ")])], 1) : _vm.isPercentage(_vm.state) ? _c('div', {
    staticClass: "stile-success"
  }, [_c(VProgressCircular, {
    attrs: {
      "size": 70,
      "value": _vm.state.value.value,
      "width": 4,
      "color": _vm.color
    }
  }, [_vm._v("\n          " + _vm._s(_vm.state.value.value) + "\n        ")])], 1) : _vm.stateAggregationValue ? _c('span', [Array.isArray(_vm.stateAggregationValue) && _vm.stateAggregationValue.length > 0 ? _c('span', _vm._l(_vm.stateAggregationValue, function (elementName, index) {
    return _c('div', {
      key: index,
      staticClass: "stile-flex"
    }, [_c('div', {
      staticClass: "text-caption text-truncate"
    }, [_c(VIcon, {
      attrs: {
        "size": "25",
        "color": 'danger'
      }
    }, [_vm._v("fal fa-times")]), _vm._v("\n                " + _vm._s(elementName) + "\n            ")], 1)]);
  }), 0) : _c('div', {
    staticClass: "stile-success"
  }, [!Array.isArray(_vm.stateAggregationValue) && typeof _vm.stateAggregationValue === 'object' ? [_c('div', {
    style: 'position: relative; margin: 0px auto; font-size: ' + _vm.stateAggregationValidTextFontSize + 'px; width: 80px; height: 80px; border-radius: 50%; color: white; background-color:' + _vm.successColor
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "50%",
      "transform": "translateY(-50%) translateX(-50%)",
      "left": "50%"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.stateAggregationValidText) + "\n              ")])])] : [_c(VIcon, {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "size": "80",
      "color": 'success'
    }
  }, [_vm._v("fal fa-check-circle")])]], 2)]) : _c('div', [_c('div', {
    staticClass: "stile-flex"
  }, [_c('div', {
    staticClass: "text-caption text-truncate"
  }, [_vm.isTemperature(_vm.state) ? _c('span', [_c(VIcon, {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("fal fa-thermometer-three-quarters")]), _vm._v("\n               \n            ")], 1) : _vm._e(), _c('span', {
    staticClass: "font-weight-medium"
  }, [_vm._v(_vm._s(_vm.state.value.value))]), _vm._v("\n            " + _vm._s(_vm.state.properties.unit) + "\n          ")])])])]), _c('div', {
    staticClass: "stile-date-container"
  }, [_c('div', {
    staticClass: "text-caption text-truncate date-text"
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.lastUpdate')) + ": " + _vm._s(_vm.localizeDate(_vm.state.value.time)) + "\n      ")])])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };